export enum GeofenceShapeType {
  Round = 'round',
  Rectangular = 'rectangular'
}
